// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"re","lowTopMargin":"rf","rightColumnWrapper":"rh","rightColumnTitle":"ri","title":"rj"};